import { useEffect, useState } from 'react';
import useVersionCheck from 'hooks/useVersionCheck';

import { ReactComponent as RotateRightArrow } from 'assets/rotate_right_arrow.svg';

import styles from './styles.module.scss';

const VersionUpdateBanner = () => {
  const isUpdateAvailable = useVersionCheck();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!isUpdateAvailable) {
      setDismissed(false);
    }
  }, [isUpdateAvailable]);

  if (!isUpdateAvailable || dismissed) {
    return null;
  }

  return (
    <div role="status" aria-live="polite" className={styles.banner}>
      <RotateRightArrow aria-hidden="true" className={styles.icon} />

      {/* Content */}
      <div className={styles.content}>
        <span className={styles.title}>
          A new version is available to update
        </span>

        <button type="button" onClick={() => window.location.reload()} className={styles['refresh-btn']}>
          Update onBeacon
        </button>
      </div>

      {/* Close button */}
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss update notification"
        className={styles['close-btn']}
      >
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M12 4L4 12M4 4l8 8" stroke="#8F97A5" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
};

export default VersionUpdateBanner;
